import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { walletsModelAtom } from '@root/entities/wallet/atoms'
import { WalletModelShort } from '@root/entities/wallet/ui'

import type { TransactionListItemVariant } from './transaction-list-item'
import type { Transaction } from '../../model'

type TransactionListItemWalletProps = {
  tx: Transaction.Transaction
  variant: TransactionListItemVariant
}

// TODO: Ivan - the wallet resolution and WalletShort rendering logic here
// duplicates the behavior in TransactionDetails. Extract a shared helper
// (e.g. a reusable hook or utility that selects the "from" wallet based on
// tx.swapInfo?.from / tx.transferInfo?.from and returns it for rendering)
// and use it in both TransactionListItemWallet and TransactionDetails
// to avoid duplication.
export const TransactionListItemWallet: React.FC<
  TransactionListItemWalletProps
> = ({ tx, variant }) => {
  const [wallet] = useAtom(
    (ctx) => {
      const model = ctx.spy(walletsModelAtom)
      const wallets = ctx.spy(model.wallets)
      const wallet = wallets.find(
        (it) =>
          it.address === tx.swapInfo?.from ||
          it.address === tx.transferInfo?.from,
      )

      return wallet
    },
    [tx.swapInfo?.from, tx.transferInfo?.from],
  )

  if (!wallet) {
    return <Empty>-</Empty>
  }

  return <WalletShort size="xs" wallet={wallet} data-variant={variant} />
}

const Empty = styled(Typography).attrs({
  variant: 'body4-semi-bold',
  component: 'div',
})`
  color: var(--text-10);

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
`

const WalletShort = styled(WalletModelShort)`
  gap: 4px;

  &[data-variant='square'] {
    gap: 2px;
    font-size: var(--typography-body-5-semi-bold-font-size);
    line-height: var(--typography-body-5-semi-bold-line-height);
    font-weight: var(--typography-body-5-semi-bold-font-weight);
  }
`
